import QueryString from 'rlink-querystring';
const telemetryKeyMapping = {
  currency: 'dimension2',
  country: 'dimension3',
  language: 'dimension4',
  igc: 'metric1',
};

export default class Tracker {
  constructor (ga = global.ga) {
    this.ga = ga;
    let data = this.sessionTelemetry();
    if (this.ga) {
      for (let key in data) {
        this.ga('set', this.getCustomDimension(key), data[key]);
      }
    }
  }
  trackView (url) {
    if (this.ga) {
      this.ga('send', 'pageview', url);
    }
  }

  trackNav (url) {
    if (this.ga) {
      this.ga('send', 'event', 'outbound', 'click', url);
    }
  }

  getCustomDimension (telemetryKey) {
    return telemetryKeyMapping[telemetryKey];
  }

  sessionTelemetry () {
    if (typeof window !== 'undefined' && window.location) {
      let pathQuery = new QueryString(window.location.path).toSingleValueDict();
      let hashQuery = {};
      let match = window.location.hash.match(/\?(.*)$/);
      if (match) {
        hashQuery = new QueryString(match[1]).toSingleValueDict();
      }
      let query = Object.assign(pathQuery, hashQuery);
      return {
        currency: query.currency,
        country: query.country,
        language: query.language,
        igc: query.supply,
      };
    } else {
      return {};
    }
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-telemetry/Tracker.js